import { render, staticRenderFns } from "./paymentInProgress.vue?vue&type=template&id=36f0d85a&scoped=true&"
import script from "./paymentInProgress.vue?vue&type=script&lang=js&"
export * from "./paymentInProgress.vue?vue&type=script&lang=js&"
import style0 from "./paymentInProgress.vue?vue&type=style&index=0&id=36f0d85a&scoped=true&lang=scss&"
import style1 from "./paymentInProgress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f0d85a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCol,VDialog})
